import * as React from "react";

import { connect } from "react-redux";

import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceFieldForceSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.FieldForce}
        >
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.IfYesHaveOngoingSymptomsOrMedicationBeenOngoingForMoreThan12Months),
                    getQuestionConfig(props.questionConfigs, questionIds.IfYesHaveOngoingSymptomsOrMedicationBeenOngoingForMoreThan12MonthsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HasThereBeenAnyChangeToVisionOrOngoingMedicalConditionSinceLastQuestionnaire),
                    getQuestionConfig(
                        props.questionConfigs,
                        questionIds.HasThereBeenAnyChangeToVisionOrOngoingMedicalConditionSinceLastQuestionnaireFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AreAnySymptomsOrMedicationNewWithinLast12MonthsFieldForce),
                    getQuestionConfig(props.questionConfigs, questionIds.AreAnySymptomsOrMedicationNewWithinLast12MonthsFieldForceFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceFieldForceSection = connect(makeMapStateToQuestionnaireSectionProps(sections.FieldForce.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceFieldForceSectionUnconnected);
